import { formatKes } from "lib/format";

function pct(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return `${value}%`;
  return `${n.toLocaleString("en-KE", { minimumFractionDigits: 0, maximumFractionDigits: 3 })}%`;
}

export default function SettlementStatement({ settlement, className = "" }) {
  const c = settlement.currency || "KES";
  const lines = [
    { op: "", label: "Gross revenue", value: formatKes(settlement.grossRevenue, c) },
    { op: "−", label: "Deductions", value: formatKes(settlement.deductions, c) },
    { op: "=", label: "Net revenue", value: formatKes(settlement.netRevenue, c), strong: true },
    { op: "×", label: "Your effective share", value: pct(settlement.clientSharePercentage) },
    { op: "=", label: "Your share amount", value: formatKes(settlement.clientShareAmount, c), strong: true, highlight: true },
  ];

  return (
    <div className={className}>
      <div className="overflow-hidden rounded-xl border border-gray-200 dark:border-white/10">
        {lines.map((line) => (
          <div
            key={line.label}
            className={`flex items-center justify-between gap-3 px-3 py-2 text-sm ${
              line.highlight ? "bg-brand-50 dark:bg-brand-400/10" : "border-b border-gray-100 last:border-0 dark:border-white/5"
            }`}
          >
            <span className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
              <span className="inline-block w-3 text-center font-mono text-xs text-gray-400" aria-hidden="true">
                {line.op}
              </span>
              {line.label}
            </span>
            <span className={`text-right ${line.strong ? "font-semibold text-navy-700 dark:text-white" : "text-navy-700 dark:text-white"}`}>
              {line.value}
            </span>
          </div>
        ))}
      </div>
      <p className="mt-2 overflow-x-auto whitespace-nowrap rounded-lg bg-gray-50 px-3 py-2 font-mono text-[11px] text-gray-600 dark:bg-white/5 dark:text-gray-300">
        your share = (gross revenue − deductions) × share % = ({formatKes(settlement.grossRevenue, c)} − {formatKes(settlement.deductions, c)}) ×{" "}
        {pct(settlement.clientSharePercentage)} = {formatKes(settlement.clientShareAmount, c)}
      </p>
      {/* When a period mixes revenue sources on different rules — the flat KES 1 of each
          deposit fee is 100% the partner's, the rest follows their ordinary percentage —
          the rate above is the blended result, not a rate anyone agreed to. Saying so
          stops it reading as a contract term that disagrees with the rules card. */}
      <p className="mt-1 text-[11px] text-gray-500 dark:text-gray-400">
        The effective share is this period's own blend: each revenue source is paid at its own rule&rsquo;s rate, and this is what they came to
        together. Per-transaction rates are on the Revenue page.
      </p>
    </div>
  );
}
